import { render, staticRenderFns } from "./StockValue.vue?vue&type=template&id=71b353bf&"
import script from "./StockValue.vue?vue&type=script&lang=js&"
export * from "./StockValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports